/* eslint-disable */
import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
//css
import 'contents/assets/scss/page/accounting.scss';
//component
import PopSelectSubject from '../_PopSelectSubject.js'; //과목선택
import PopFeeManageCard from '../_PopFeeManageCard'; //카드사별 수수료 관리
import PopMatching from '../_PopMatching'; //매칭 확인
import Tab from '../../../component/Inc/Tab';
function AccountingMonth() {
  const [modalSubject, setSubject] = useState(false);
  const [modalFeeManageCard, setFeeManageCard] = useState(false);
  const [modalMatching, setModalMatching] = useState(false);
  const navigate = useNavigate();
  const [tabIdx, setTabIdx] = useState(0);
  const [tabMonthIdx, setTabMonthIdx] = useState(0);
  const [tabDayIdx, setTabDayIdx] = useState('All');
  const tab01 = [
    {title: '전체', value: 0},
    {title: '미확인', value: 1},
    {title: '일치', value: 2},
    {title: '불일치', value: 3},
    {title: '입금위치 모름', type: 'red', value: 4}
  ];
  const tab02 = [
    {title: '1월', value: 0},
    {title: '2월', value: 1},
    {title: '3월', value: 2},
    {title: '4월', value: 3},
    {title: '5월', value: 4},
    {title: '6월', value: 5},
    {title: '7월', value: 6},
    {title: '8월', value: 7},
    {title: '9월', value: 8},
    {title: '10월', value: 9},
    {title: '11월', value: 10},
    {title: '12월', value: 11}
  ];
  const tab03 = [
    {title: '전체', value: 'All'},
    {title: '1', value: 0},
    {title: '2', value: 1},
    {title: '3', value: 2},
    {title: '4', value: 3},
    {title: '5', value: 4},
    {title: '6', value: 5},
    {title: '7', value: 6},
    {title: '8', value: 7},
    {title: '9', value: 8},
    {title: '10', value: 9},
    {title: '11', value: 10},
    {title: '12', value: 11},
    {title: '13', value: 12},
    {title: '14', value: 13},
    {title: '15', value: 14},
    {title: '16', value: 15},
    {title: '17', value: 16},
    {title: '18', value: 17},
    {title: '19', value: 18},
    {title: '20', value: 19},
    {title: '21', value: 20},
    {title: '22', value: 21},
    {title: '23', value: 22},
    {title: '24', value: 23},
    {title: '25', value: 24},
    {title: '26', value: 25},
    {title: '27', value: 26},
    {title: '28', value: 27},
    {title: '29', value: 28},
    {title: '30', value: 29},
    {title: '31', value: 30}
  ];
  return (
    <main className="com_container">
      <div className="com_center_wrap p_accounting_month">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu8_1 active">월별 입금관리</h2>
          <div className="com_btn_wrap">
            <button className="com_btn orange s btn_settings" onClick={() => setFeeManageCard(true)}>
              카드사 별 수수료 관리
            </button>
            <button className="com_btn orange s btn_plus">입금내역 추가</button>
          </div>
        </section>
        <section className="com_pg_container">
          <div className="box full">
            <div className="com_board_list__top">
              <div className="board_select">
                <select className="select">
                  <option value="이지수능 (본사)">이지수능 (본사)</option>
                </select>
                <Tab data={tab01} tab={tabIdx} setTab={setTabIdx} tabStyle="fit_cont" />
              </div>
              <section className="com_board_search end">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <hr className="com_divider" />
            <div className="check com_radio_wrap padding_y">
              <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
              <label htmlFor="rdo01">전체</label>
              <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
              <label htmlFor="rdo02">카드</label>
              <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
              <label htmlFor="rdo03">가상계좌</label>
              <input type="radio" name="rdo" id="rdo04" className="com_chk circle" />
              <label htmlFor="현금">카드</label>
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <div className="board_select month">
                <select className="select">
                  <option>2022</option>
                </select>
                <div className="tab_wrap">
                  <Tab data={tab02} tab={tabMonthIdx} setTab={setTabMonthIdx} tabStyle="month" />
                  <Tab data={tab03} tab={tabDayIdx} setTab={setTabDayIdx} tabStyle="day" />
                </div>
              </div>
              <div className="com_count_wrapper end">
                <div className="operators">
                  <div className="operators_label">
                    <span className="operators_count">총 입금 건수</span>
                    <span className="operators_value">98건</span>
                  </div>
                </div>
                <div className="turnover">
                  <div className="turnover_label">
                    <span className="turnover_count">총 입금액</span>
                    <span className="turnover_value">46,500,000</span>
                  </div>
                </div>
              </div>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="50" />
                <col width="100" />
                <col width="85" />
                <col width="90" />
                <col width="70" />
                <col width="100" />
                <col width="110" />
                <col width="85" />
                <col width="85" />
                <col width="70" />
                <col width="70" />
                <col width="auto" />
                <col width="100" />
                <col width="70" />
                <col width="70" />
                <col width="70" />
                <col width="70" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>입금일</th>
                  <th>학생명</th>
                  <th>과목</th>
                  <th>회차 / T</th>
                  <th>할인</th>
                  <th>상품가격</th>
                  <th>교사</th>
                  <th>담임</th>
                  <th>입금자</th>
                  <th>입금방법</th>
                  <th>입금방법</th>
                  <th>입금회차 /금액</th>
                  <th>수수료</th>
                  <th>승인번호</th>
                  <th>비고</th>
                  <th>보기</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>2022, 08, 25</td>
                  <td>
                    <button className="btn_link">홍학생123</button>
                  </td>
                  <td>
                    수학 <button onClick={() => setSubject(true)} className="btn_edit"></button>
                  </td>
                  <td>16회 / 2T</td>
                  <td>형제할인 2%</td>
                  <td>46,650,000</td>
                  <td>
                    <button className="btn_link">김교사103</button>
                  </td>
                  <td>
                    <button className="btn_link">김담임103</button>
                  </td>
                  <td>김길동</td>
                  <td>카드</td>
                  <td>[국민]6546-645-*****-645</td>
                  <td className="td_point">3회/ 300,000</td>
                  <td>45,000</td>
                  <td>
                    <span className="btn_link blue">1324</span>
                  </td>
                  <td>
                    <button onClick={() => setModalMatching(true)} className="com_red_txt">
                      미확인
                    </button>
                  </td>
                  <td className="td_point">
                    <button className="txt btn_link" onClick={() => navigate('/Accounting/Month/Detail')}>
                      보기
                    </button>
                  </td>
                </tr>
                {[...Array(8)].map((i, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td>2022, 08, 25</td>
                    <td>
                      <button className="btn_link">홍학생123</button>
                    </td>
                    <td>수학</td>
                    <td>16회 / 2T</td>
                    <td>형제할인 2%</td>
                    <td>46,650,000</td>
                    <td>
                      <button className="btn_link">김교사103</button>
                    </td>
                    <td>
                      <button className="btn_link">김담임103</button>
                    </td>
                    <td>김길동</td>
                    <td>카드</td>
                    <td>[국민]6546-645-*****-645</td>
                    <td className="td_point">3회/ 300,000</td>
                    <td>45,000</td>
                    <td>
                      <span className="btn_link blue">1324</span>
                    </td>
                    <td className="com_blue_txt">확인</td>
                    <td className="td_point">
                      <button className="txt btn_link" onClick={() => navigate('/Accounting/Month/Detail')}>
                        보기
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td className="bg_col"></td>
                  <td className="bg_col"></td>
                  <td className="bg_col"></td>
                  <td className="bg_col"></td>
                  <td className="bg_col"></td>
                  <td className="bg_col"></td>
                  <td className="bg_col td_point">660,665,000</td>
                  <td className="bg_col"></td>
                  <td className="bg_col"></td>
                  <td className="bg_col"></td>
                  <td className="bg_col"></td>
                  <td className="bg_col">[국민]6546-645-*****-645</td>
                  <td className="bg_col td_point">321,646,684</td>
                  <td className="bg_col">646,000</td>
                  <td className="bg_col">
                    <span className="btn_link blue">1324</span>
                  </td>
                  <td className="bg_col td_point">확인</td>
                  <td className="bg_col"></td>
                </tr>
              </tfoot>
            </table>
            <div className="com_btn_wrap bottom end right">
              <button className="com_btn black xs btn_down_orange">양식 다운로드</button>
              <button className="com_btn orange xs">카드사 승인번호 등록</button>
            </div>
          </div>
        </section>
      </div>
      <PopSelectSubject open={modalSubject} close={() => setSubject(false)} />
      <PopFeeManageCard open={modalFeeManageCard} close={() => setFeeManageCard(false)} />
      <PopMatching open={modalMatching} close={() => setModalMatching(false)} />
    </main>
  );
}

export default AccountingMonth;
